import { ChangeDetectionStrategy, Component, OnInit, OnDestroy, signal } from '@angular/core';
import { Subscription } from 'rxjs';
import { MusicDataService } from '../music-data.service';
import { FavouriteAlbumsService } from '../favourite-albums.service';
import { FavouriteArtistsService } from '../favourite-artists.service';
import { FavouriteHeartComponent } from '../shared/favourite-heart.component';
import { RelatedArtistsComponent } from '../shared/related-artists.component';
import { MatIcon } from '@angular/material/icon';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { MatCard, MatCardContent } from '@angular/material/card';
import { FlexModule } from '@ngbracket/ngx-layout/flex';
import { MatChipSet, MatChip } from '@angular/material/chips';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-artist-discography',
  templateUrl: './artist-discography.component.html',
  styleUrls: ['./artist-discography.component.css'],
  imports: [MatCard, MatCardContent, FlexModule, RouterLink, MatChipSet, MatChip, MatIcon, RelatedArtistsComponent, FavouriteHeartComponent]
})
export class ArtistDiscographyComponent implements OnInit, OnDestroy {
  albums = signal<any[]>([]);
  artist = signal<any>({
    external_urls: {}, followers: 0, genre: [], href: '', id: '',
    images: '', name: '', popularity: 0, type: '', uri: ''
  });

  private idSub: Subscription;
  private postSub: Subscription;
  private albumSub: Subscription;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private data: MusicDataService,
    protected favourites: FavouriteAlbumsService,
    protected artistFavourites: FavouriteArtistsService
  ) { }

  toggleFavourite(album: { id: string; name: string }): void {
    this.favourites.toggle(album.id, album.name);
  }

  ngOnInit() {
    this.favourites.ensureIds();
    this.artistFavourites.ensureIds();
    this.idSub = this.route.params.subscribe(params => {
      const id = params.id;

      this.postSub = this.data.getArtistById(id).subscribe((data) => {
        this.artist.set({
          external_urls: data.external_urls,
          followers: data.followers,
          genre: data.genres,
          href: data.href,
          id: data.id,
          images: data.images[1]?.url || '',
          name: data.name,
          popularity: data.popularity,
          type: data.type,
          uri: data.uri
        });
      });

      this.albumSub = this.data.getAlbumsByArtistId(id).subscribe((dataUnfiltered) => {
        // Simple unique filter by name
        const uniqueAlbums = dataUnfiltered.items.filter((album, index, self) =>
          index === self.findIndex((t) => t.name === album.name)
        );

        this.albums.set(uniqueAlbums.map(d => ({
          artists: d.artists,
          external_urls: d.external_urls,
          href: d.href,
          id: d.id,
          images: d.images[1]?.url || '',
          name: d.name,
          release_date: d.release_date,
          total_tracks: d.total_tracks,
          uri: d.uri,
          popularity: this.artist().popularity
        })));
      });
    });
  }
  ngOnDestroy() {
    this.idSub?.unsubscribe();
    this.postSub?.unsubscribe();
    this.albumSub?.unsubscribe();
  }
}


